import Checkbox from './Checkbox';
export type { CheckboxProps } from './Checkbox.types';

export default Checkbox;
